import React from "react";
import litheImg from "../Assets/Projects/lithe.png";
import { CgPlayButtonO, CgWebsite } from "react-icons/cg";

const projects = [
  {
    title: "Lithe",
    description:
      "A mobile app for coding on the phone. Integrates with GitHub and Google, supports code editing via chatbot interface, and handles basic Git commands for version control.",
    image: litheImg,
    links: [
      { href: "/lithe/video.html", label: "Watch the tour", icon: CgPlayButtonO },
      {
        href: "https://play.google.com/store/apps/details?id=com.litheapp.app",
        label: "Google Play",
        icon: CgWebsite,
      },
    ],
    tags: ["React Native", "GitHub API", "AI"],
  },
];

function Projects() {
  return (
    <section id="projects" className="py-24 px-6">
      <div className="fade-section max-w-3xl mx-auto">
        <h2 className="text-sm font-medium text-accent uppercase tracking-widest mb-4">
          Projects
        </h2>
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-12">
          Recent Work
        </h3>

        <div className="space-y-8">
          {projects.map((project, i) => (
            <div
              key={i}
              className="project-card border border-dark-border rounded-xl overflow-hidden bg-dark-card"
            >
              <div className="md:flex">
                <div className="md:w-2/5">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-48 md:h-full object-cover"
                  />
                </div>
                <div className="p-6 md:p-8 md:w-3/5 flex flex-col justify-center">
                  <h4 className="text-xl font-semibold text-white mb-3">
                    {project.title}
                  </h4>
                  <p className="text-neutral-400 text-sm leading-relaxed mb-4">
                    {project.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-5">
                    {project.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-2 py-1 rounded-md bg-dark border border-dark-border text-neutral-500"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex flex-wrap gap-x-6 gap-y-2">
                    {project.links.map(({ href, label, icon: Icon }) => (
                      <a
                        key={href}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-light transition-colors"
                      >
                        <Icon />
                        {label}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
